"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAUTH_USER_RETRIEVAL_ERROR = exports.OAUTH_INVALID_ORIGIN = exports.OAUTH_ORIGIN_USED = exports.OAUTH_UNKNOWN_ERROR = exports.OAUTH_REDIRECT_ERROR = exports.OAUTH_ONE_TAP_USED = exports.OAUTH_LOGIN_FROM_REDIRECT = exports.REGIONAL_SETTINGS_ERROR = exports.LOGIN_USER_HAS_VALID_TOKEN = exports.ON_LOGIN_REGIONAL_SETTINGS_ERROR = exports.ON_LOGIN_REGIONAL_SETTINGS_UPDATE = exports.MODAL_OPEN = exports.API_REQUEST_FAILED = exports.API_SUCCESS = exports.API_REQUEST = exports.API_ERROR = void 0;
// FIXME: use import type {} from "...";

const API_ERROR = {
  category: "general",
  action: "api error",
  destinations: {
    exponea: false,
    ga: false,
    logmole: true,
    bigQuery: true
  }
};
exports.API_ERROR = API_ERROR;
const API_REQUEST = {
  category: "general",
  action: "api request",
  destinations: {
    exponea: false,
    ga: false,
    logmole: true,
    bigQuery: true
  }
};
exports.API_REQUEST = API_REQUEST;
const API_SUCCESS = {
  category: "general",
  action: "api success",
  destinations: {
    exponea: false,
    ga: false,
    logmole: true,
    bigQuery: true
  }
};
exports.API_SUCCESS = API_SUCCESS;
const API_REQUEST_FAILED = {
  category: "general",
  action: "api failed",
  destinations: {
    exponea: false,
    ga: false,
    logmole: true,
    bigQuery: true
  }
};
exports.API_REQUEST_FAILED = API_REQUEST_FAILED;
const MODAL_OPEN = {
  category: "general",
  action: "modal open",
  destinations: {
    exponea: false,
    ga: false,
    logmole: true,
    bigQuery: true
  }
};

// OnLogin events - events connected to login flow
exports.MODAL_OPEN = MODAL_OPEN;
const ON_LOGIN_REGIONAL_SETTINGS_UPDATE = {
  category: "login",
  action: "regional settings updated",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.ON_LOGIN_REGIONAL_SETTINGS_UPDATE = ON_LOGIN_REGIONAL_SETTINGS_UPDATE;
const ON_LOGIN_REGIONAL_SETTINGS_ERROR = {
  category: "login",
  action: "regional settings update error",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};

// Login events
exports.ON_LOGIN_REGIONAL_SETTINGS_ERROR = ON_LOGIN_REGIONAL_SETTINGS_ERROR;
const LOGIN_USER_HAS_VALID_TOKEN = {
  category: "login",
  action: "valid token on load page",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};

// Regional settings
exports.LOGIN_USER_HAS_VALID_TOKEN = LOGIN_USER_HAS_VALID_TOKEN;
const REGIONAL_SETTINGS_ERROR = {
  category: "general",
  action: "regional settings update error from modal",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};

// OAuth events: sign in via Google, Facebook + Google One Tap
exports.REGIONAL_SETTINGS_ERROR = REGIONAL_SETTINGS_ERROR;
const OAUTH_LOGIN_FROM_REDIRECT = {
  category: "login",
  action: "login url auth token",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_LOGIN_FROM_REDIRECT = OAUTH_LOGIN_FROM_REDIRECT;
const OAUTH_ONE_TAP_USED = {
  category: "login",
  action: "google one tap used",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_ONE_TAP_USED = OAUTH_ONE_TAP_USED;
const OAUTH_REDIRECT_ERROR = {
  category: "login",
  action: "oauth redirect error",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_REDIRECT_ERROR = OAUTH_REDIRECT_ERROR;
const OAUTH_UNKNOWN_ERROR = {
  category: "login",
  action: "oauth unknown error",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_UNKNOWN_ERROR = OAUTH_UNKNOWN_ERROR;
const OAUTH_ORIGIN_USED = {
  category: "login",
  action: "oauth origin used",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_ORIGIN_USED = OAUTH_ORIGIN_USED;
const OAUTH_INVALID_ORIGIN = {
  category: "login",
  action: "oauth invalid origin error",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_INVALID_ORIGIN = OAUTH_INVALID_ORIGIN;
const OAUTH_USER_RETRIEVAL_ERROR = {
  category: "login",
  action: "oauth user retrieval error",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OAUTH_USER_RETRIEVAL_ERROR = OAUTH_USER_RETRIEVAL_ERROR;